var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.117 17.2234H133.675H14.4868H7.2159C3.22981 17.2234 0 20.6945 0 24.9739V111.095C0 115.374 3.22981 118.845 7.2159 118.845H58.8683C58.8683 124.55 63.1747 129.175 68.4857 129.175H80.8477C86.1605 129.175 90.467 124.55 90.467 118.845H142.117C146.104 118.845 149.333 115.374 149.333 111.095V24.9739C149.333 20.6945 146.104 17.2234 142.117 17.2234Z",
    fill: "#001593",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.104 105.627H90.3518C83.046 105.627 76.903 110.755 75.1626 117.693H74.1748C72.4345 110.755 66.2952 105.627 58.9857 105.627H17.23C15.0814 105.627 13.3335 103.724 13.3335 101.376V4.25317C13.3335 1.90695 15.0814 0 17.23 0H58.9857C67.6461 0 74.6696 7.20288 74.6696 16.0869C74.6696 7.20288 81.6894 0 90.3518 0H132.104C134.256 0 136 1.90284 136 4.25317V101.376C136 103.724 134.256 105.627 132.104 105.627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.d6f375730cbc67e1f6d9be101484a869.svg";
export { ForwardRef as ReactComponent };